// biome-ignore lint/style/noExportedImports: Part of i18n setup
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/i18n/locales/en.json" with { type: "json" };
import ms from "@/i18n/locales/ms.json" with { type: "json" };

export const supportedLanguages = {
  en: "EN",
  ms: "BM",
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: en,
      },
      ms: {
        translation: ms,
      },
    },
    supportedLngs: Object.keys(supportedLanguages),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
